<template>
	<div>
		<Menu
			ref="menuRef"
			:menu-options="options"
			menu-options-wrapper-classes="py-1 border border-won-gray-light rounded flex flex-col gap-1"
		>
			<template #menuButton>
				<div class="flex w-fit items-center gap-1">
					<span
						class="text-base font-medium text-won-dark"
					>
						{{ displayMap[selectedValue] }}
					</span>
                    
					<ChevronDownIcon
						class="size-4 text-won-dark-blue"
					/>
				</div>
			</template>
            
			<template #menuItem="{ option }">
				<button
					class="
                        flex w-full items-center gap-2.5 px-2.5 py-1 disabled:opacity-50
                    "
					:class="option?.disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-won-bg-blue'"
					:disabled="option?.disabled"
					@click="() => updateUserPermissionHandler(option?.value)"
				>
					<span class="size-4">
						<CheckIcon
							v-if="selectedValue === option.value"
							class="size-4 text-won-green"
						/>
					</span>
                    
					<span class="text-base">
						{{ option?.actionText }}
					</span>
				</button>
			</template>
		</Menu>
	</div>
</template>

<script setup>
import { ref, toRefs } from 'vue';

import { CheckIcon, ChevronDownIcon } from '@heroicons/vue/24/outline';
import Menu from '../library/menu.vue';


const props = defineProps({
	options: {
		type: Array,
		default() {
			return [];
		}
	},
	displayMap: {
		type: Object,
		default() {
			return {};
		}
	}
});
const { options, displayMap } = toRefs(props);

const selectedValue = defineModel();
const menuRef = ref(null);

const updateUserPermissionHandler = (newPermission) => {
	selectedValue.value = newPermission;
};
</script>
